import { render, staticRenderFns } from "./message_versions_modal.vue?vue&type=template&id=6437a64d&"
import script from "./message_versions_modal.vue?vue&type=script&lang=js&"
export * from "./message_versions_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports